export function getEditableValues(ids) {
    return jQuery.ajax({
        url: ajaxurl,
        method: 'post',
        data: {
            action: 'acp_editing_single_request',
            method: 'get_editable_values',
            ids: ids,
            list_screen: AC.list_screen,
            layout: AC.layout,
            _ajax_nonce: AC.ajax_nonce
        }
    });
}
